import _ from 'lodash';
import xlsxExport from '../../../export/xlsxExport';
import app from '$$app';
import generateHtmlPageForExport from './templateForExportPDF';
import ExportModule from "../../../export/exportjs/index";
import dateHelper from '$$dateFormatsHelper';

// it's hacky to have 2 models here, but we to it to d not calculate path
// for the whole collection without export to excel
// because it's better to cache  it
import projectsModel from '$$projectModel';
import globalStore from '../../../../store/main';
import reportsHelpers from '../helpers';
// ----------------------------------------------------------------------

const __ = window.__;
const levelColumn = '$level';
const taskPathColumn = 'project_name';
let indentColumn = 'project';

// const exportToExcel = function (options) {

//   const exportOptions = {
//     title: options.title,
//     worksheets: []
//   };

//   const splitLevelsToColumns = {
//     depth: innerHelpers.getMaxDepthBylevelColumn(options.data, levelColumn) - 1,
//     indentColumn,
//     levelColumn,
//     label: __("export_excel_task_name")
//   };

//   const columns = innerHelpers.prepareColumns(options.columns, { splitLevelsToColumns: options.isTree?splitLevelsToColumns:false, isTree: options.isTree });
//   const rows = innerHelpers.prepareData(options.data, columns);

//   exportOptions.worksheets.push({
//     title: options.title,
//     rows,
//     columns
//   });

//   xlsxExport.export(exportOptions);
// };

// const innerHelpers = {

//   prepareColumns(columns, options) {
//     let splitLevelsToColumns = options.splitLevelsToColumns;
//     let cols = [];
//     if (splitLevelsToColumns && splitLevelsToColumns.depth) {
//       for (let i = 0; i < splitLevelsToColumns.depth; i++) {
//         let index = (i + 1);
//         let label = '';//(splitLevelsToColumns.depth === index) ? splitLevelsToColumns.label : '';
//         cols.push({
//           label: label,
//           key: splitLevelsToColumns.indentColumn,
//           colWidth: 7,
//           preprocessor: function (row, column) {
//             let out = { value: '' };
//             if (row[splitLevelsToColumns.levelColumn] === index) {
//               out.value = row[splitLevelsToColumns.indentColumn];
//               out.merge = { horizontal: splitLevelsToColumns.depth - index + 1 };
//             }
//             return out;
//           }
//         });
//       }
//     }

//     _.each(columns, column => {
//       let header = column.header;
//       if(column.id === 'time' || column.id === 'time_logs'){
//         header = `${column.header} (${__('common_minutes').toLowerCase()})`
//       }

//       const col = {
//         label: header,
//         key: column.id,
//         type: column.excelFormat
//       }

//       if (column.id === "task_name") {
//         col.preprocessor = (row) => ({ value: row.task_name});
//       }

//       if (column.id === "project_name") {
//         col.preprocessor = (row) => ({ value: row.project_name});
//       }

//       cols.push(col);
//     });

//     if (options.isTree) {
//       cols.push({
//         label: __('export_excel_level'),
//         key: '$level',
//         type: 'number'
//       });
//     }

//     return cols;
//   },

//   getMaxDepthBylevelColumn: function (rows, levelColumn) {
//     let depth = 0;
//     rows.map(function (row, j) {
//       if (row.data) {
//         depth = innerHelpers.getMaxDepthBylevelColumn(row.data, levelColumn)
//       } else if (row[levelColumn] > depth) {
//         depth = row[levelColumn];
//       }
//     });
//     return depth;
//   },

//   getTaskParentsPath (taskId, ganttId) {
//     const breadcrumbsTasks = globalStore.getters['tasksModel/getDataForBreadcrumbs'](taskId, ganttId, {});
//     const projectData = projectsModel.getProjectDataById(ganttId);
//     const breadcrumbsText = breadcrumbsTasks.reduce(function (sum, elem) {
//       return sum + " / " + elem.text;
//     }, "");
//     const result = projectData.name + breadcrumbsText;

//     return result;
//   },

//   prepareData(data, columns, parentLevel = 0) {
//     let level = parentLevel + 1;
//     let out = [];

//     _.each(data, (obj, i) => {
//       let row = {};
//       let isGroupedRow = !_.isUndefined(obj.groupValue);
//       _.each(columns, (column, j) => {
//         let formattedValue = '';
//         if (!_.isUndefined(obj[column.key])) {
//           if (column.key === levelColumn) {
//             formattedValue = level;
//           } else if (column.key === taskPathColumn && obj.task_id && obj.gantt_id) {
//             formattedValue = innerHelpers.getTaskParentsPath(obj.task_id, obj.gantt_id);
//           } else {
//             formattedValue = obj[column.key];
//           }
//         }

//         if (isGroupedRow && column.key === indentColumn) {
//           formattedValue = obj.groupValue;
//         }
//         row[column.key] = formattedValue;
//       });

//       let attributes = isGroupedRow ? {
//         font: { bold: true },
//         border: {
//           top: { style: 'thin', color: { argb: 'FFBFBFBF' } },
//           bottom: { style: 'thin', color: { argb: 'FFBFBFBF' } },
//           right: { style: 'thin', color: { argb: 'FFBFBFBF' } }
//         },
//         fill: {
//           type: 'pattern',
//           pattern: 'solid',
//           fgColor: {
//             argb: 'FFEEEEEE'
//           }
//         }
//       } : {};
//       out.push({ data: row, attributes });

//       if (obj.data) {
//         out = out.concat(innerHelpers.prepareData(obj.data, columns, level));
//       }
//     });

//     return out;
//   }
// }

// const outerObject = {
//   exportToExcel
// };

// export default outerObject;

const GROUP_COLORS ={
  0: '#FFFFFF',
  1: '#F2F2F2',
  2: '#F8F8F8',
  3: '#FCFCFC',
  4: '#FCFCFC',
};

const innerHelpers = { // old export helpers
  prepareColumns(columns, options) {
    const splitLevelsToColumns = options.splitLevelsToColumns;
    const cols = [];

    if (splitLevelsToColumns && splitLevelsToColumns.depth) {
      for (let i = 0; i < splitLevelsToColumns.depth; i++) {
        const index = (i + 1);
        const label = '';// (splitLevelsToColumns.depth === index) ? splitLevelsToColumns.label : '';

        cols.push({
          label,
          key: splitLevelsToColumns.indentColumn,
          colWidth: 7,
          preprocessor: (row, column) => {
            const out = { value: '' };

            if (row[splitLevelsToColumns.levelColumn] === index) {
              out.value = row[splitLevelsToColumns.indentColumn];
              out.merge = { horizontal: splitLevelsToColumns.depth - index + 1 };
            }

            return out;
          },
        });
      }
    }

    _.each(columns, column => {
      let header = column.header;
      const columnId = column.accessorKey || column.id;

      if (columnId === 'time' || columnId === 'time_logs') {
        header = `${column.header} (${__('common_minutes').toLowerCase()})`;
      }

      const col = {
        label: header,
        key: columnId,
        type: column.excelFormat,
      };

      col.preprocessor = row => ({ value: row[columnId] });

      if (columnId === 'status') {
        col.preprocessor = row => {
          const projectStatusesLocales = ['no_status_locale', 'on_track_locale', 'at_risk_locale', 'off_track_locale'];
          const label = projectStatusesLocales.includes(row.status.label) ? __(row.status.label) : row.status.label;

          return { value: label };
        };
      }

      if (columnId === 'progress') {
        col.preprocessor = row => ({ value: `${row.progress?.percentage || row.progress}%` });
      }

      if (columnId === 'date') {
        

        col.preprocessor = row => {
          const formatDateValue = webix.Date.dateToStr(dateHelper.getDateFormat())(row.date);

          return { value: formatDateValue };
        };
      }

      cols.push(col);
    });

    if (options.isTree) {
      cols.push({
        label: __('export_excel_level'),
        key: '$level',
        type: 'number',
      });
    }

    return cols;
  },

  getMaxDepthBylevelColumn(rows, levelColumn) {
    let depth = 0;

    rows.map((row, j) => {
      if (row.data) {
        depth = innerHelpers.getMaxDepthBylevelColumn(row.data, levelColumn);
      } else if (row[levelColumn] > depth) {
        depth = row[levelColumn];
      }
    });

    return depth;
  },

  getTaskParentsPath(taskId, ganttId) {
    const breadcrumbsTasks = globalStore.getters['tasksModel/getDataForBreadcrumbs'](taskId, ganttId, {});
    const projectData = projectsModel.getProjectDataById(ganttId);
    const breadcrumbsText = breadcrumbsTasks.reduce((sum, elem) => `${sum} / ${elem.text}`, '');
    const result = projectData.name + breadcrumbsText;

    return result;
  },

  prepareData(data, columns, parentLevel = 0) {
    const projectBreadcrumbsColumn = ['project_name', 'project'];
    const level = parentLevel + 1;
    let out = [];

    _.each(data, (obj, i) => {
      const row = {};
      const isGroupedRow = !_.isUndefined(obj.groupValue);

      _.each(columns, (column, j) => {
        let formattedValue = '';

        // if (!_.isUndefined(obj[column.key])) {
        //   if (column.key === levelColumn) {
        //     formattedValue = level;
        //   } else if (breadcrumbsColumn.includes(column.key) && obj.task_id && obj.gantt_id) {
        //     formattedValue = innerHelpers.getTaskParentsPath(obj.task_id, obj.gantt_id);
        //   } else {
        //     formattedValue = obj[column.key];
        //   }
        // }

        if (!_.isUndefined(obj[column.key])) {
          if (column.key === levelColumn) {
            formattedValue = obj[levelColumn] + 1;
          } else if (projectBreadcrumbsColumn.includes(column.key) && obj.task_id && obj.gantt_id) {
            formattedValue = innerHelpers.getTaskParentsPath(obj.task_id, obj.gantt_id);
          } else {
            formattedValue = obj[column.key];
          }
        }

        if (isGroupedRow && column.key === indentColumn) {
          formattedValue = obj.groupValue;
        }

        row[column.key] = formattedValue;
      });

      const attributes = isGroupedRow ? {
        font: { bold: true },
        border: {
          top: { style: 'thin', color: { argb: 'FFBFBFBF' } },
          bottom: { style: 'thin', color: { argb: 'FFBFBFBF' } },
          right: { style: 'thin', color: { argb: 'FFBFBFBF' } },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'FFEEEEEE',
          },
        },
      } : {};

      out.push({ data: row, attributes });

      if (obj.data) {
        out = out.concat(innerHelpers.prepareData(obj.data, columns, level));
      }
    });

    return out;
  },
};

class Export {
  getCurrency() {
    const currencies = GT.currency.map(({ ID, VALUE}) => ({
      id: ID,
      code: `${VALUE}`
    }));
    const enableCurrency = globalStore.getters['teamSetting/enableCurrency'];
    const currentCurrency = currencies.find((item) => item.id === globalStore.getters['teamSetting/currency']) || this.currencies[0];

    if (enableCurrency) {
      return `(${currentCurrency.code})`;
    }

    return '';
  }
  getColumnTitleAndType(value, columnId, reportType = null) {
    const varianceSpecialSymbol = {
      progress: '(%)',
      budget: this.getCurrency(),
      time: `(${__('common_minutes')})`,
    }
    const formatting = {
      actual_progress: `${value} (%)`,
      baseline_progress: `${value} (%)`,
      progress: `${value} (%)`,
      actual_cost: `${value} ${this.getCurrency()}`,
      budget: `${value} ${this.getCurrency()}`,
      baseline_budget: `${value} ${this.getCurrency()}`,
      cum_actual_cost: `${value} ${this.getCurrency()}`,
      cum_budget: `${value} ${this.getCurrency()}`,
      cum_baseline_budget: `${value} ${this.getCurrency()}`,
      logs: `${value} (${__('common_minutes')})`,
      estimation: `${value} (${__('common_minutes')})`,
      baseline_estimation: `${value} (${__('common_minutes')})`,
      cum_logs: `${value} (${__('common_minutes')})`,
      cum_estimation: `${value} (${__('common_minutes')})`,
      cum_baseline_estimation: `${value} (${__('common_minutes')})`,
      table_time: `${value} (${__('common_minutes')})`,

      // For all report types
      cum_variance: `${value} ${varianceSpecialSymbol[reportType] || ''}`,
      variance: `${value} ${varianceSpecialSymbol[reportType] || ''}`,
    }

    const numberColumns = Object.keys(formatting);
    const isNumberType = numberColumns.find(colName => colName === columnId);

    return {
      title: formatting[columnId] || value,
      type: isNumberType ? 'number' : 'text',
    };
  }

  prepareTanstackTasks(rows, grouping, aggregationProps, reportType) {
    const tasksMap = globalStore.getters['tasksModel/tasksByIds'];
    const hasGrouping = Array.isArray(grouping) && grouping.length > 0;
    const aggregationData = [];
    let enableLevel = false;

    const mapRowToTask = row => {
      const hasSubRows = Array.isArray(row.subRows) && row.subRows.length > 0;
      // const splitRowId = row.id.split(':');
      // const rowId = splitRowId[splitRowId.length - 1];
      const rowId = row.id;

      if (hasSubRows) {
        enableLevel = true;

        aggregationProps.forEach(prop => {
          let groupValue = row.getGroupingValue(prop);

          if (groupValue === undefined) {
            return;
          }

          if (reportType === 'time') {
            groupValue = Math.ceil(+groupValue * 60);
          }
          
          if (row.depth === 0) {
            const existedTotalAggregationColumnIndex = aggregationData.findIndex(a => a.idColumn === prop && a.id === 0);

            if (existedTotalAggregationColumnIndex > -1) {
              const existedColumn = aggregationData[existedTotalAggregationColumnIndex];
              const sumValue = +existedColumn.value + +groupValue;
              aggregationData[existedTotalAggregationColumnIndex] = {
                ...existedColumn,
                value: sumValue === 0 ? '0' : sumValue,
              };
            } else {
              aggregationData.push({
                id: 0,
                idColumn: prop,
                value: groupValue === 0 ? '0' : groupValue,
              });
            }
          }

          aggregationData.push({
            id: rowId,
            idColumn: prop,
            value: groupValue === 0 ? '0' : groupValue,
          });
        });
        
        const originalData = row.original;
        const groupColumnId = row.groupingColumnId;
        const color = originalData[groupColumnId]?.color || '#000000';
        const groupRowStyle = {
          color,
          fontSize: 13,
          bold: true,
          background: GROUP_COLORS[row.depth],
        }

        return {
          type: 'group',
          title: this.getGroupTitle(row, tasksMap),
          data: { id: rowId },
          items: row.subRows.map(mapRowToTask),
          style: groupRowStyle,
        };
      }


      if (!enableLevel) {
        aggregationProps.forEach(prop => {
          let groupValue = row.getGroupingValue(prop);
  
          if (groupValue === undefined) {
            return;
          }

          if (reportType === 'time') {
            groupValue = Math.ceil(+groupValue * 60);
          }
  
          const existedColumnIndex = aggregationData.findIndex(a => a.idColumn === prop);
  
          if (existedColumnIndex > -1) {
            const existedColumn = aggregationData[existedColumnIndex];
            const sumValue = +existedColumn.value + +groupValue;
            aggregationData[existedColumnIndex] = {
              ...existedColumn,
              value: sumValue === 0 ? '0' : sumValue,
            };
          } else {
            aggregationData.push({
              id: 0,
              idColumn: prop,
              value: groupValue === 0 ? '0' : groupValue,
            });
          }
        });
      }

      return {
        type: 'row',
        data: {
          id: row.id,
          ...this.getCellValues(row.original, reportType),
        },
      };
    };

    if (!hasGrouping) {
      return {
        tasksRows: rows.map(mapRowToTask),
        aggregationData,
        enableLevel,
      }
    }

    const topGroupRows = rows.filter(row => row.groupingColumnId === grouping[0]);
    const sourceRows = topGroupRows.length ? topGroupRows : rows;

    return {
      tasksRows: sourceRows.map(mapRowToTask),
      aggregationData,
      enableLevel,
    };
  }

  getCellValues(data, reportType) {
    const values = {};

    Object.keys(data).forEach(key => {
      const originalValue = data[key];
      const isResourcesValue = ['assignee', 'creator', 'user'].includes(key);

      let value = originalValue;

      if (['task', 'project'].includes(key) || isResourcesValue) {
        const isArray = Array.isArray(originalValue);

        if (isArray && isResourcesValue) {
          if (originalValue.length > 0) {
            value = originalValue.reduce((string, val, index) => (
              index > 0 ? `${string}, ${val.name}` : `${string}${val.name}`
            ), '');
          } else {
            value = __('notAssigned');
          }
        } else {
          value = originalValue.name;
        }
      }

      if (['progress', 'actual_progress', 'baseline_progress'].includes(key)) {
        if (originalValue?.percentage || originalValue?.percentage === 0) {
          value = originalValue.percentage;
        } else {
          value = originalValue;
        }
      }

      if (['logs', 'estimation', 'baseline_estimation', 'cum_logs', 'cum_estimation', 'cum_baseline_estimation', 'table_time'].includes(key)) {
        value = Math.ceil(+value * 60);
      }

      if (['variance', 'cum_variance'].includes(key) && reportType === 'time') {
        value = Math.ceil(+value * 60);
      }

      if (key === 'status') {
        value = originalValue.label;
      }

      if (key === 'table_date') {
        value = originalValue.value;
      }

      const { type } = this.getColumnTitleAndType(value, key);
      const resultValue = type === 'number' ? +value : value;

      values[key] = resultValue;
    });

    return values;
  }

  getGroupTitle(row, tasksMap) {
    const groupColumnId = row.groupingColumnId;
    const groupValue = row.groupingValue;
    const originalData = row.original;
    const isResourcesValue = ['assignee', 'creator', 'user'].includes(groupColumnId);

    if (isResourcesValue) {
      if (groupValue === '-1') {
        return __('notAssigned');
      }

      const resourceData = globalStore.getters['resourcesModel/getResourceById'](groupValue);

      if (resourceData?.name) {
        return resourceData.name;
      }

      return 'Error resource group name'
    }

    if (['task'].includes(groupColumnId)) {
      return tasksMap[+groupValue]?.text ?? originalData[groupColumnId]?.name ?? 'Error task group name';
    }

    if (['project'].includes(groupColumnId)) {
      const projectId = originalData[groupColumnId]?.id;
      const projectData = projectsModel.getProjectDataById(+projectId);

      return projectData?.name || 'Error project name';
    }

    if (['table_time'].includes(groupColumnId)) {
      return `${__('group_by_time')}: ${reportsHelpers.getTextValue(groupValue)}`;
    }

    if (['table_date'].includes(groupColumnId)) {
      return originalData[groupColumnId]?.value || 'Error table date group name';
    }

    return groupValue;
  }

  async exportTanstackTableDataToExcel(exportData) {
    const { title, tableInstance, aggregatedColumns = [], nameTaskColumnKey, reportType = null } = exportData;

    if (tableInstance) {
      const { columnVisibility, grouping, expanded } = tableInstance.getState();
      const columns = tableInstance.getAllColumns()
        .map(col => ({
          header: col.columnDef.header,
          accessorKey: col.columnDef.accessorKey,
        }))
        .filter(col => col.accessorKey in columnVisibility && columnVisibility[col.accessorKey])
        .map((col, index) => {
          const { title, type } = this.getColumnTitleAndType(col.header, col.accessorKey, reportType);
          
          const column = {
            key: col.accessorKey,
            label: title,
            type: type,
            order: index + 1,
            colWidth: 35,
          };

          if (aggregatedColumns.includes(column.key)) {
            column.type = 'aggregation';
          }

          return column;
        });

      // tableInstance.toggleAllRowsExpanded(true);
      const rows = tableInstance.getExpandedRowModel().rows;

      // tableInstance?.setOptions(prev => ({
      //   ...prev,
      //   state: {
      //     ...prev.state,
      //     expanded,
      //   },
      // }));

      const filteredAggregationProps = aggregatedColumns.filter(columnName => columns.find(col => col.key === columnName));
      const { tasksRows, aggregationData, enableLevel } = this.prepareTanstackTasks(rows, grouping, filteredAggregationProps, reportType);

      await ExportModule.exportToExcel({
        fileName: title,
        columns,
        tasks: tasksRows,
        worksheetName: title,
      }, {
        logo: true,
        logoImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAA8CAYAAABYfzddAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASpSURBVHgB7dyBddpIEMbxyVXg64ASch2QCu6ugvgq8F0F5iqIO8CpIOlA6sDuADpIOpjsBngRZHfZXe0IQf6/93i2kfzNSCCQVgIRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwT6q6cLdO29q421sp5P7nX3f7sv//lRQ6WZa1/1sq+N7d7WWf83K6LGqzzl4O/VrnU6OsxqwZLPxBV9jHfSBjWZjRnfz/puaB0B8bb3BZAtNb6abIj6wrixo3sRxW3kgDvlMx8sbJnde1sXE/Fid39y7inWSKLMury/hDCoRyhstivc6meEyokV/Dym8yb6+5M7rH4F5+3ni9pY7flfG7w2tpqxcbrxPlYwbmvAF/dbd/CuZ/SEx7L+P53fOVtOOXrfXG4PP+NszvB/m4FaGdf5mQK7c8cyziB7XuMrPOyXoxaLFOWmRY5rfqL5VzKzWszH0XOte5jcpvvA/SxpNWjI4DFswGsawP3ge1F+7HJmPWr66l3zPycl41t+72zuVtS3JK14n1eh2b36q/VM6t1LByC+/Aj4H7tvLzIM6dFp5SSli42yfN3C0HZu0S+/77ugsNe6/h4+Kz5+UieR8i969LcqRQiwzL/Fb9pXJupcasXapxV2YVKL0ZTP8SmL48kxlcFo2f7F+V5BQu3+gMy/xW/aVybqWGlcl3oXV3iWFowzqVcylaaPDq8+D3p8D02sEsf/pkG7j/UTNHpn8FWkEKaQVBXMkK07JL47pEzn3kfxaDefxxb+jF4i6RG10W3e2yh/L8fW9zc3K1yLDMV0OXriEVWuWUuMQgVskpmGViWmjw6nk4Mux+9xeDfA7MV/UuvM8OXcjgXxD8oNZCgAldYgPuZSSNXzb5HLjvY+A+/4mlqhFktxH37sd/gUkLYWS6lSku1+SS0IOSXQfdHQNvtHA35ySj0/EeItm5PSRHpnNzWq3XGmPz1Uanx4dBF6khFVrlTG7KFaDxU0elXmp7GMzbRbJXJTmJ/NEZlvnW/ZXU0N14R2x8xd9fNe5h0evsTLkCdPch+1aWNT0M5vVPmo1mSix6LH90hmW+dX+lNXT34r7RsHWLGq16nZWpVoC2e/c96Ep7CMwfG5kuyolkj86wzLfur6aGpk9TrlrUSNRukjO5qVaAtn33PViW9BDpe5lTSAq1yLDMt+6vtobGTzF6f7WoEanbJKfE1VwLrbtBh2Vgkv/GjSwSHgH/U0ZKjEzjAtzj8ex+rCKT18rpvmNqaFDj7IUbGX2G3imPPiuc6iEj/1EzlqUgb3SGZb51f2NruFk/hR+J78fJyce8FbkGamhQIzTCuK7odRPIeUgtS0F86knDBjxxj5oeZEw+5q2IsWv6OGHoNMD/Uu4pM7uW/yqbreDi9lfi+S803AYm38SXMrTagHux0Q9+355Me059oD7hYyDrNVLzdNpZiSdNL+V6GdFLRX4vZfqTvy2uburH1Ehc/pp6zFvp5Rro7lRK6+/v7TT85dv+mNVfBVX9rqk/rgbzWY+JZTnqoWKddGNyWvVi1aN1fy1r6PEX7Xd6fAxs/vwFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABX5Bu5jpj5ei04TAAAAABJRU5ErkJggg==',
        subHeaderText: title,
        includeAggregation: aggregationData.length > 0,
        aggregationData,
        footerText: __('excel_export_footer_postfix1'),
        enableLevel,
        colorMap: {
          TITLE_BAR_BG: '#0B5F52',
          SUBHEADER_BG: '#1A7367',
        },
        constants: {
          nameTaskColumnKey: nameTaskColumnKey,
        }
      });
    }
  }

  exportToExcel(options) { // old export: used in timeTracking.js
    const title = options?.title;
    const exportOptions = {
      title,
      worksheets: [],
    };

    indentColumn = options?.isTanstack ? 'identColumnKey' : indentColumn;

    const splitLevelsToColumns = {
      depth: innerHelpers.getMaxDepthBylevelColumn(options.data, levelColumn) - (options?.isTanstack ? 0 : 1),
      indentColumn,
      levelColumn,
      label: __('export_excel_task_name'),
    };

    const columns = innerHelpers.prepareColumns(options.columns, { splitLevelsToColumns: options.isTree ? splitLevelsToColumns : false, isTree: options.isTree });
    const rows = innerHelpers.prepareData(options.data, columns);

    exportOptions.worksheets.push({
      title,
      rows,
      columns,
    });

    xlsxExport.export(exportOptions);
  }

  async exportReportGraphicToPdf(options) {
    const node = document.documentElement.querySelector('#report_export_id')
    || document.documentElement.querySelector('.report_export_id');

    const chartType = node.getAttribute('data-chart-type') || null;
    const date = new Date();
    const fileName = `${options.title}_(Ganttro.com) ${date.toLocaleDateString()}`;
    const html = await generateHtmlPageForExport(node, {
      fileName,
      reportRange: options.range,
      reportYear: options.year || null,
      width: 1122,
      chartType,
    });

    const body = JSON.stringify({
      socketId: app.socket.id,
      exportType: 'report',
      exportReport: {
        format: 'pdf',
        fileName,
        chartType,
        landscape: chartType !== 'pie',
        userId: user.id,
      },
      html,
    });

    // const blob = new Blob([html], { type: 'text/html' });
    // const url = URL.createObjectURL(blob);

    // window.open(url);
    /**
     * This code is to view the result for pdf
    */

    await fetch('/api/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    });
  }
}

const reportsExport = new Export();

export default reportsExport;
